import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

class FloatingTaskPill extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // EVENT HANDLERS

    handleClick = () => {
        this.props.handleClick(this.props.floatingTask);
    }

    // RENDER METHOD

    render = () => {
        return (
            <div className="panel panel-default panel-pmtask">
                <div className="panel-heading" role="tab" id="headingOne">
                    <h4 className="panel-title">
                        <a onClick={this.handleClick} className="clearfix" style={{wordWrap : "break-word", "cursor" : "pointer"}} data-toggle="collapse" data-parent="#accordion" aria-expanded="true" aria-controls="collapseOne">
                            <span className="md-chevron-right"></span>
                            {this.props.text}
                            <span className="pull-right">{this.props.floatingTask ? "(" + this.props.floatingTask.createdBy + ")" : null}</span>
                        </a>
                    </h4>
                </div>
            </div>
        );
    }
}

FloatingTaskPill.propTypes = {
    floatingTask: PropTypes.object,
    handleClick: PropTypes.func,
    text: PropTypes.string
};

export default connect()(FloatingTaskPill);



/** WEBPACK FOOTER **
 ** ./src/app/components/FloatingTaskPill.js
 **/